import { useEffect, useState } from 'react';

export const useVoteColors = () => {
    const [voteColors, setVoteColors] = useState({});

    useEffect(() => {
        const style = getComputedStyle(document.body);
        const colors = [
            style.getPropertyValue('--clr-1'),
            style.getPropertyValue('--clr-2'),
            style.getPropertyValue('--clr-3'),
            style.getPropertyValue('--clr-4'),
            style.getPropertyValue('--clr-5'),
            style.getPropertyValue('--clr-6'),
            style.getPropertyValue('--clr-7')
        ];
        setVoteColors({
            ano: colors[0],
            ne: colors[1],
            'zdržel se': colors[2],
            nehlasoval: colors[3],
            'nepřít.': colors[4],
            tajná: colors[5],
            omluven: colors[6]
        });
    }, []);

    return voteColors;
};

export const useAttendanceColors = () => {
    const [attendanceColors, setAttendanceColors] = useState({});

    useEffect(() => {
        const style = getComputedStyle(document.body);
        const colors = [
            style.getPropertyValue('--clr-1'),
            style.getPropertyValue('--clr-2'),
            style.getPropertyValue('--clr-3'),
            style.getPropertyValue('--clr-4'),
            style.getPropertyValue('--clr-5'),
            style.getPropertyValue('--clr-6'),
            style.getPropertyValue('--clr-7')
        ];
        setAttendanceColors({
            přítomnost: colors[0],
            'částečná přítomnost': colors[2],
            nepřítomnost: colors[1]
        });
    }, []);

    return attendanceColors;
};
